import React, { useEffect } from "react";
import { BrowserRouter as Router, Switch, Route, Redirect, useLocation } from "react-router-dom";
import CONSTANSTS from "common/constansts";

import routes from "routes/routes";
import pathnames from "routes/pathnames";
import withAuthenticate from "contexts/with-authenticate";
import AppLayout from "components/app-layout";
import { createBrowserHistory } from "history";
import refreshToken from "contexts/refresh-token";

const App = () => {
    return (
        <Router>
            <MainApp />
        </Router>
    );
};

const MainApp = () => {
    const location = useLocation();

    const history = createBrowserHistory();
    useEffect(() => {
        refreshToken(history);
    }, []);

    useEffect(() => {
        checkAccessMatrix();
    }, [location.pathname]);

    function checkAccessMatrix() {
        const storedAccessMatrix = localStorage.getItem("accessMatrix");
        if (localStorage.getItem("@storage_token")) {
            if (!storedAccessMatrix) {
                console.log("accessMatrix not found, fetching...");
                getAccessMatrixInfo();
            } else {
                console.log("Using cached accessMatrix:", JSON.parse(storedAccessMatrix));
            }
        }
    }

    function getAccessMatrixInfo() {
        const token = localStorage.getItem("@storage_token");
        fetch(process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.COMMON_GET_INFO, {
            method: "GET",
            headers: {
                "Accept-language": "en",
                "X-DEVICE-OS": "Web",
                Authorization: `Bearer ${token}`,
            },
        })
            .then((response) => response.json())
            .then((res) => {
                if (res.responseCode === 200) {
                    console.log("AccessMatrix Fetch Success!");
                    localStorage.setItem("accessMatrix", JSON.stringify(res.result));
                }
            })
            .catch((error) => console.error("Error fetching AccessMatrix:", error));
    }

    return (
        <AppLayout>
            <Switch>
                {routes.map((route) => {
                    const ProtectedComponent = withAuthenticate(route.component, route.authenticate);
                    return (
                        <Route
                            key={`${route.path}_index`}
                            path={route.path}
                            exact
                            render={(props) => <ProtectedComponent {...props} />}
                        />
                    );
                })}
                <Redirect to={pathnames.page404} />
            </Switch>
        </AppLayout>
    );
};

export default App;
